import { render, staticRenderFns } from "./DeptRoleAuthModal.vue?vue&type=template&id=d0a37c0c&scoped=true"
import script from "./DeptRoleAuthModal.vue?vue&type=script&lang=js"
export * from "./DeptRoleAuthModal.vue?vue&type=script&lang=js"
import style0 from "./DeptRoleAuthModal.vue?vue&type=style&index=0&id=d0a37c0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a37c0c",
  null
  
)

export default component.exports